import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'chevronRight',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-chevron-right wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path fill-rule="nonzero" d="M9.346 3.143a.5.5 0 0 0-.701.002l-.748.747a.493.493 0 0 0-.002.7L15.306 12l-7.41 7.406a.5.5 0 0 0-.057.632l.058.069.748.748a.494.494 0 0 0 .7 0l8.512-8.505a.492.492 0 0 0 0-.7Z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-chevron-right.svg',
    category: 'Core',
    tags: ['navigation', 'arrow'],
};
export default icon;
